import { render, staticRenderFns } from "./DocumentTableResources.vue?vue&type=template&id=fb11be4e&scoped=true"
import script from "./DocumentTableResources.vue?vue&type=script&lang=ts"
export * from "./DocumentTableResources.vue?vue&type=script&lang=ts"
import style0 from "./DocumentTableResources.vue?vue&type=style&index=0&id=fb11be4e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb11be4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb11be4e')) {
      api.createRecord('fb11be4e', component.options)
    } else {
      api.reload('fb11be4e', component.options)
    }
    module.hot.accept("./DocumentTableResources.vue?vue&type=template&id=fb11be4e&scoped=true", function () {
      api.rerender('fb11be4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/DocumentTableResources.vue"
export default component.exports